<template>
    <div class="wrapper wrapper-content wrapper-boxed wrapper2019">
        
        <div class="page-heading m-b-lg">
            <h1>Carbon - master</h1>
            <p></p>
        </div>

        <div class="row">
            <div class="col-md-12">
                
                <div class="ibox ibox-add-user">
                    <div class="ibox-title">
                        <div class="row">
                                    <div class="col-xl-10">
                                        <h2>Details</h2>
                                    </div>
                                    <div class="col-xl-2 text-right">
                                        <button type="button" data-toggle="drawer" data-target=".drawer-sla-overview" aria-foldedopen="false" aria-controls="drawer-sla-overview" class="btn btn-link">
                                            <i class="fal fa-pen"></i>
                                        </button>
                                    </div>
                                </div><!-- /.row -->
                    </div>
                    <div class="ibox-content">
                        <div class="row row-clear-md-6-lg-4">
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group form-group-material">
                                                <label class="control-label">App Url</label>
                                                <p class="form-control-static">{{ environment.app_url }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group form-group-material">
                                                <label class="control-label">API Url</label>
                                                <p class="form-control-static">{{ environment.api_url }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-lg-4">
                                            <div class="form-group form-group-material">
                                                <label class="control-label">Cluster</label>
                                                <p class="form-control-static">Production</p>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-lg-6">
                                            <div class="form-group form-group-material">
                                                <label class="control-label">RDS Host</label>
                                                <p class="form-control-static">{{ environment.rds_host }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-8 col-lg-6">
                                            
                                        </div>
                                        <div class="col-md-8 col-lg-6">
                                            
                                        </div>
                                        
                                    </div>


                        

                    </div>
                </div>
            </div>
        </div>

         <div class="row">
            <div class="col-md-12">
                <div class="ibox ibox-add-user">
                    <div class="ibox-title">
                        <h5>Terraform Builds</h5>
                    </div>
                    <div class="ibox-content">
                        <ul class="list-sla">
                            <li>
                                <div class="row">
                                    <div class="col-12 col-md-4 col-lg-1">
                                        <div class="client truncate">
                                            #33
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-2">
                                        2 Days Ago
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-5 text-right">
                                        Approved By Jason Smith
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4 text-right">
                                        <span class="label label-warning">Needs Confirmation</span>
                                    </div>
                                </div><!-- /.row -->
                            </li>
                             <li>
                                <div class="row">
                                    <div class="col-12 col-md-4 col-lg-1">
                                        <div class="client truncate">
                                            #32
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-2">
                                        15 Days Ago
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-5 text-right">
                                        
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4 text-right">
                                        <span class="label label-success">Applied</span>
                                    </div>
                                </div><!-- /.row -->
                            </li>
                             <li>
                                <div class="row">
                                    <div class="col-12 col-md-4 col-lg-1">
                                        <div class="client truncate">
                                            #31
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-2">
                                        20 Days Ago
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-5 text-right">
                                        
                                    </div>
                                    <div class="col-12 col-md-4 col-lg-4 text-right">
                                        <span class="label label-default">No Changes</span>
                                    </div>
                                </div><!-- /.row -->
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="ibox ibox-add-user">
                    <div class="ibox-title">
                        <h5>Laravel Environment Keys</h5>
                    </div>
                    <div class="ibox-content">
                        <table class="table env-keys">
                            <thead>
                            <tr>
                                <th class="text-right">Key</th>
                                <th></th>
                                <th>Val</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td class="text-right">APP_ENV</td>
                                <td class="text-center">=</td>
                                <td>Production</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">APP_URL</td>
                                <td class="text-center">=</td>
                                <td>https://api.carbon.codium.com.au</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">APP_DEBUG</td>
                                <td class="text-center">=</td>
                                <td>false</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right"><input class="form-control text-right" type="text" value="JS_APP_URL"/></td>
                                <td class="text-center">=</td>
                                <td><input class="form-control" type="text" value="https://carbon.codium.com.au"/></td>
                                <td><button type="button" class="float-right btn btn-primary btn-xs">Save</button></td>
                            </tr>
                            <tr>
                                <td class="text-right">APP_KEY</td>
                                <td class="text-center">=</td>
                                <td>dBs60jmXVHv1qmwUT3sfY8s4LJF2Cvxr</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">JWT_SECRET</td>
                                <td class="text-center">=</td>
                                <td>MiyO7TYdVH2zm450NKpfrrINoDpQkWoz</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">JWT_BLACKLIST_GRACE_PERIOD</td>
                                <td class="text-center">=</td>
                                <td>12</td>
                                <td></td>
                            </tr>
                            

                            </tbody>
                            <tfoot>
                                <tr>
                                    <td><input class="form-control text-right" type="text" value=""/></td>
                                    <td class="text-center">=</td>
                                    <td><input class="form-control text-right" type="text" value=""/></td>
                                    <td><button type="button" class="float-right btn btn-primary btn-xs">Add</button></td>
                                </tr>

                            </tfoot>
                        </table>
 
                    </div>
                </div>
            </div>
        </div>
        

            


		<environment-form></environment-form>
    </div>
</template>

<script>

    import { Selectize, LaddaButton } from 'components/form/input'
    import { notify, http } from 'utils'
    import EnvironmentForm from 'components/environments/EnvironmentForm'
    
    export default {
        data: function () {
            return {
                environment: {
                    cluster_id: 1,
                    app_url: 'https://carbon.codium.com.au',
                    api_url: 'https://api.carbon.codium.com.au',
                    rds_host: 'tf-codium-production.ch66levpagqo.ap-southeast-2.rds.amazonaws.com',
                    rds_username: 'cbn_name',
                    rds_password: 'sdfsdfdfsfdg',
                    sqs_urls: [
                        'https://sqs.ap-southeast-2.amazonaws.com/795476257944/tf-production-cbn.fifo',
                        'https://sqs.ap-southeast-2.amazonaws.com/795476257944/tf-production-cbn.fifo'
                    ],
                    sqs_region: 'ap-southeast-2',

                },
                productionClusters: [
                    {
                        id: 1,
                        text: 'Codium Production'
                    },
                    {
                        id: 2,
                        text: 'Pickstar Production'
                    }
                ]
            }
        },
        components: {
            Selectize,
            LaddaButton,
            EnvironmentForm
        },
        methods: {

        }
    }
</script>

<style scoped>
    table.env-keys {
        margin-bottom:0px;
    }

    table button.btn {
        margin-top:4px;
    }
</style>